
class CartProgressBar extends HTMLElement {
    constructor() {
    super();
    this.goalAmount = parseFloat(this.dataset.goal) * 100;
    this.discountPercentage = parseInt(this.dataset.discount);
    this.messageText = this.dataset.messageText;
    this.goalReachedText = this.dataset.goalReachedText;
    this.showIcon = this.dataset.showIcon === 'true';
    this.icon = this.dataset.icon;
    this.successIcon = this.dataset.successIcon;
    this.messageEl = this.querySelector('[data-message]');
    this.fillEl = this.querySelector('[data-fill]');
    this.goalMessageEl = this.querySelector('[data-goal-message]');
    }

    // connectedCallback() {
    //     this.updateProgressBar();
    //     document.addEventListener('cart:updated', () => this.updateProgressBar());
    // }

    connectedCallback() {
        this.updateProgressBar();
        this.cartUpdateUnsubscriber = window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            return this.updateProgressBar();
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    async updateProgressBar() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const cartTotal = cart.original_total_price;
        const itemCount = cart.item_count;
        
        if (itemCount === 0) {
        this.classList.add('hidden');
        return;
        }
        
        this.classList.remove('hidden');
        this.updateDisplay(cartTotal);
    } catch (error) {
        console.error('Error fetching cart:', error);
    }
    }

    updateDisplay(cartTotal) {
    const remaining = this.goalAmount - cartTotal;
    const progressPercent = Math.min((cartTotal / this.goalAmount) * 100, 100);
    
    this.fillEl.style.width = progressPercent + '%';

    if (remaining > 0) {
        const remainingFormatted = this.formatMoney(remaining);
        let message = this.messageText.replace('[amount]', remainingFormatted).replace('[discount]', this.discountPercentage + '%');
        
        if (this.showIcon) {
        message = '<span class="ai-progress-bar-icon">' + this.icon + '</span>' + message;
        }
        
        this.messageEl.innerHTML = message;
        this.goalMessageEl.textContent = '';
    } else {
        let message = this.goalReachedText.replace('[discount]', this.discountPercentage + '%');
        
        if (this.showIcon) {
        message = '<span class="ai-progress-bar-icon">' + this.successIcon + '</span>' + message;
        }
        
        this.messageEl.innerHTML = message;
        this.goalMessageEl.textContent = '';
    }
    }

    formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
    }
}

customElements.define('cart-progress-bar', CartProgressBar);